<div class="failed-content">
    <span [innerHTML]="message | safe: 'html'"></span>
</div>
